import { defineComponent as f, ref as k, computed as y, openBlock as s, createElementBlock as u, createElementVNode as i, normalizeClass as t, unref as o, createBlock as x, createCommentVNode as m, renderSlot as C, toDisplayString as v } from "vue";
import { IconCheckmarkSmall as V } from "@cypress-design/vue-icon";
const r = {
  wrapper: "relative flex items-center",
  hiddenInput: "absolute inset-0 w-0 h-0 opacity-0",
  labelTag: "flex items-center",
  visibleCheckbox: "border border-solid rounded h-[16px] w-[16px] flex flex-shrink-0 items-center text-white",
  trueLabel: "block ml-[8px] text-[16px] leading-[24px] font-light select-none"
}, c = {
  indigo: "border-indigo-500 bg-indigo-400",
  jade: "border-jade-500 bg-jade-400",
  red: "border-red-500 bg-red-400",
  disabled: "border-gray-200 bg-gray-100",
  empty: "border-gray-200 bg-white"
}, w = { class: "relative flex items-center" }, B = ["id", "name", "disabled", "checked"], S = ["for"];
function A() {
  return String(Date.now().toString(32) + Math.random().toString(16)).replace(
    /\./g,
    ""
  );
}
const I = /* @__PURE__ */ f({
  __name: "Checkbox",
  props: {
    id: { default: () => A() },
    name: {},
    checked: { type: Boolean },
    color: { default: "indigo" },
    disabled: { type: Boolean },
    modelValue: { type: [Boolean, Array] },
    label: {}
  },
  emits: ["update:modelValue", "change"],
  setup(b, { emit: p }) {
    const e = b, l = k(
      (Array.isArray(e.modelValue) ? e.name ? e.modelValue.includes(e.name) : !1 : e.modelValue) || e.checked
    ), d = p;
    function h() {
      if (l.value = !l.value, Array.isArray(e.modelValue)) {
        const a = [...e.modelValue];
        if (!e.name)
          return;
        const n = a.indexOf(e.name);
        n === -1 ? a.push(e.name) : a.splice(n, 1), d("update:modelValue", a);
      } else
        d("update:modelValue", l.value);
      d("change", l.value);
    }
    const g = y(
      () => e.disabled ? c.disabled : l.value ? c[e.color] : c.empty
    );
    return (a, n) => (s(), u("span", w, [
      i("input", {
        id: a.id,
        class: t(o(r).hiddenInput),
        name: a.name || a.id,
        type: "checkbox",
        disabled: e.disabled,
        checked: l.value,
        onChange: h
      }, null, 42, B),
      i("label", {
        class: t(o(r).labelTag),
        for: a.id
      }, [
        l.value ? (s(), x(o(V), {
          key: 0,
          strokeColor: "white",
          class: "absolute"
        })) : m("", !0),
        i("span", {
          class: t([g.value, o(r).visibleCheckbox])
        }, null, 2),
        C(a.$slots, "label", {}, () => [
          a.label ? (s(), u("span", {
            key: 0,
            class: t([
              o(r).trueLabel,
              a.disabled ? "text-gray-500" : "text-gray-800"
            ])
          }, v(a.label), 3)) : m("", !0)
        ])
      ], 10, S)
    ]));
  }
});
export {
  I as default
};
//# sourceMappingURL=index.es.mjs.map

/* <wind-keep class="relative flex items-center absolute text-gray-500 text-gray-800 icon-dark-white inset-0 w-0 h-0 opacity-0 border border-solid rounded h-[16px] w-[16px] flex-shrink-0 text-white block ml-[8px] text-[16px] leading-[24px] font-light select-none border-indigo-500 bg-indigo-400 border-jade-500 bg-jade-400 border-red-500 bg-red-400 border-gray-200 bg-gray-100 bg-white"> */
